import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { ChipConnector } from '../ChipConnector/ChipConnector';
import { moveQuantifier, nextQuantifier, presentServiceEntries, setQuantifier } from './service-predicate';
import { ServiceConditionChip } from './ServiceConditionChip/ServiceConditionChip';
import { useServiceCatalogOptions } from './useServiceCatalogOptions';
export const GetServicesChipsTID = (parentTestId)=>getTestIds(parentTestId);
export const ServicesChips = (param)=>{
    let { testId, services, onChange } = param;
    const { ServicesChipsTestIds } = useMemo(()=>GetServicesChipsTID(testId), [
        testId
    ]);
    const serviceOptions = useServiceCatalogOptions();
    const toggleQuantifier = (quantifier)=>{
        const target = nextQuantifier(services, quantifier);
        if (target === quantifier) return;
        onChange(moveQuantifier(services, quantifier, target));
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: presentServiceEntries(services).map((param, index)=>{
            let { quantifier, predicate } = param;
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                        testId: ServicesChipsTestIds.AndConnector(index - 1),
                        tone: "and"
                    }),
                    /*#__PURE__*/ _jsx(ServiceConditionChip, {
                        testId: ServicesChipsTestIds.Chip(quantifier),
                        quantifier: quantifier,
                        predicate: predicate,
                        serviceOptions: serviceOptions,
                        onToggleQuantifier: ()=>toggleQuantifier(quantifier),
                        onChangePredicate: (next)=>onChange(setQuantifier(services, quantifier, next)),
                        onRemove: ()=>onChange(setQuantifier(services, quantifier, undefined))
                    })
                ]
            }, quantifier);
        })
    });
};
